import {Injectable} from '@angular/core';
import {BehaviorSubject, of, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DressesService {
  private selectedDresses = new BehaviorSubject([]);


  listenSelectedDresses = () => {
    return this.selectedDresses;
  }

  addDress = (value: Object) => {
    if (this.selectedDresses.getValue().indexOf(value) !== -1) {
      let index = this.selectedDresses.getValue().indexOf(value);
      this.selectedDresses.getValue().splice(index,1);
      this.selectedDresses.next(this.selectedDresses.getValue());
    }else {
      this.selectedDresses.next(this.selectedDresses.getValue().concat(value));
    }
  }


  constructor() {
  }
}
